module.exports = __webpack_public_path__ + "img/cooperationContentImg2.efa470e4.png";